import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'arrayLoop'
})
export class ArrayLoopPipe implements PipeTransform {

  transform(value: any[]): any[] {
    let myValue = value as Array<any>;
    return myValue;
  }
}
